import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  RadioGroup,
  Radio,
  Text,
} from '@chakra-ui/react';
import React from 'react';

function GridPreview({ gridRows, gridColumns }) {
  if (!gridRows?.length || !gridColumns?.length) {
    return (
      <Box p='4' bg='gray.50' borderRadius='md'>
        <Text color='gray.500' textAlign='center'>
          Configure as linhas e colunas para visualizar a matriz
        </Text>
      </Box>
    );
  }

  return (
    <Box overflowX='auto' border='1px solid' borderColor='gray.200' borderRadius='md'>
      <Table variant='simple' size='sm'>
        <Thead bg='gray.50'>
          <Tr>
            <Th w='200px'></Th>
            {gridColumns.map((col, colIndex) => (
              <Th key={colIndex} textAlign='center' fontSize='xs'>
                {col.description || `Coluna ${colIndex + 1}`}
              </Th>
            ))}
          </Tr>
        </Thead>
        <Tbody>
          {gridRows.map((row, rowIndex) => (
            <Tr key={rowIndex}>
              <Td fontWeight='500' fontSize='sm'>
                {row.description || `Linha ${rowIndex + 1}`}
              </Td>
              {gridColumns.map((col, colIndex) => (
                <Td key={colIndex} textAlign='center'>
                  <Radio 
                    isDisabled 
                    value={`${rowIndex}-${colIndex}`}
                  />
                </Td>
              ))}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
}

export default GridPreview;
